import {PayloadAction} from "@reduxjs/toolkit";
import {Dispatch} from "react";
import {InactiveOrderReminderService} from "../service/Order/InactiveOrderReminderService";
import {
    DealershipExcludedRequest,
    ProductExcludedRequest,
    SaveInactiveOrderReminderSettings,
    SendInactiveOrderReminderBatch,
} from "../shared/entities/Order/InactiveOrderReminder";

export class InactiveOrderReminderController {
    private service: InactiveOrderReminderService;

    constructor(dispatch: Dispatch<PayloadAction<unknown>>) {
        this.service = new InactiveOrderReminderService(dispatch);
    }

    public async list(params: Record<string, unknown>) {
        return this.service.list(params);
    }

    public async pendingCount(params: Record<string, unknown>) {
        return this.service.pendingCount(params);
    }

    public async recipients(dealershipId: number) {
        return this.service.recipients(dealershipId);
    }

    public async send(data: SendInactiveOrderReminderBatch) {
        return this.service.send(data);
    }

    public async settings(dealershipIds: number[]) {
        return this.service.settings(dealershipIds);
    }

    public async saveSettings(data: SaveInactiveOrderReminderSettings) {
        return this.service.saveSettings(data);
    }

    public async setDealershipExcluded(data: DealershipExcludedRequest) {
        return this.service.setDealershipExcluded(data);
    }

    public async setProductExcluded(data: ProductExcludedRequest) {
        return this.service.setProductExcluded(data);
    }
}
